import React from 'react';
import { format } from 'date-fns/format';

import { RouterLink } from '../../components/Link';
import type Document from './Document';
import { TableCell, TableRow, Badge } from '@storebrand-digital/pretzel';
import { differenceInDays } from 'date-fns';
import { getText } from '@storebrand-digital/fms-translations';

interface Props extends Document {
  id: Document.Id;
}

function DocumentTableRow({
  id,
  sourceType,
  name,
  contractNumbers,
  products,
  isRead,
  date,
}: Props) {
  const isRecent = differenceInDays(new Date(), new Date(date)) <= 40;
  const trackid =
    sourceType === 'MAIN'
      ? 'button-show|Vis pdf Main'
      : 'button-show|Vis pdf Bank';

  return (
    <TableRow>
      <TableCell className="document-name">
        <RouterLink
          to={`/${sourceType}/pdf/${id}`}
          data-trackid={trackid}
          $bold={!isRead}
        >
          <span className="document-title font-body-small-demibold">
            {name}
          </span>
          <div className="subtext">
            {products?.length > 0 && (
              <span className="font-details">{products.join(', ')}</span>
            )}
            {contractNumbers?.length > 0 && (
              <span className="contract-subtext font-details">
                {getText('filter.contract.title')}: {contractNumbers.join(', ')}
              </span>
            )}
          </div>
        </RouterLink>
      </TableCell>
      <TableCell
        className="document-contract-number"
        align="left"
        data-hj-suppress
      >
        <span className="font-body-small">{contractNumbers?.join(', ')}</span>
      </TableCell>
      <TableCell className="document-date" align="right">
        {!isRead && isRecent && (
          <Badge
            variant="info"
            density="compact"
            heading={getText('document.new.badge')}
          />
        )}
        <span className="font-body-small">{format(date, 'dd.MM.yyyy')}</span>
      </TableCell>
    </TableRow>
  );
}

export default DocumentTableRow;
